import { Component, Input } from '@angular/core';
import { BaseStepComponent } from "../../../base/base-step.component";
import { Validators } from '@angular/forms';

@Component({
    selector: 'central-notificacao-etapa1',
    templateUrl: 'central-notificacao-etapa1.component.html'
})

export class CrudCentralNotificacaoEtapa1Component extends BaseStepComponent {
    @Input() listaSistema: any[] = [];
    @Input() listaPerfil: any[] = [];
    @Input() listaDiasSemana: any[] = [];
    @Input() listaMeses: any[] = [];
    @Input() listaDiasMes: any[] = [];
    @Input() hoje = new Date();
    @Input() isHideCpf: boolean;

}


// WEBPACK FOOTER //
// ./src/app/central-notificacao/crud/etapas/central-notificacao-etapa1.component.ts